import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const RefundPolicy = () => {
  return (
    <div className="bg-black min-h-screen text-white font-sans pt-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-8 tracking-tight">Refund & Cancellation Policy</h1>
          
          <div className="space-y-8 text-gray-300 font-light leading-relaxed">
            <p>At Iryax Global, we strive to provide the best services to our customers. This Refund & Cancellation Policy outlines the terms under which refunds and cancellations are processed.</p>
            
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. General Policy</h2>
              <p>Refunds and cancellations are subject to the specific terms of the product or service purchased. Please review the terms carefully before making a purchase.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">2. Cancellation Policy</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Cancellation requests must be submitted in writing via email or through the platform dashboard.</li>
                <li>Cancellation charges may apply depending on the product/service and time of cancellation.</li>
                <li>For time-sensitive bookings, cancellations within 24 hours may incur a 50% cancellation fee.</li>
                <li>No-show or failure to use the service will result in 100% charge with no refund.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. Digital Products / Services</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Once a digital product is delivered or accessed, no refunds will be provided.</li>
                <li>If you face technical issues accessing our services, please contact support within 7 days of purchase.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. Physical Products</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Physical products can be returned within 7 days of delivery.</li>
                <li>Products must be unused, in original packaging, and in resellable condition.</li>
                <li>Return shipping costs must be borne by the customer unless the product is defective.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Membership / Subscription Plans</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Monthly subscriptions can be canceled anytime before the next billing cycle.</li>
                <li>No refunds are provided for unused days of a subscription period.</li>
                <li>Annual plans may have a pro-rata refund option if canceled within the first 30 days.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">6. Refund Processing</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Approved refunds will be processed within 5-7 business days.</li>
                <li>Refunds will be credited to the original payment method used at the time of purchase.</li>
                <li>Bank processing times may vary, and we are not responsible for delays caused by the bank.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">7. Chargebacks and Disputes</h2>
              <p>If you believe a charge has been made incorrectly, please contact us immediately. We will work with you to resolve the issue.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">8. Contact Information</h2>
              <p>For any questions regarding refunds or cancellations, please reach out to us:</p>
              <p className="mt-2 text-white">Email: <a href="mailto:info@ingrainsystem.com" className="text-blue-400 hover:underline">info@ingrainsystem.com</a></p>
            </section>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundPolicy;